import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { englishCrmMessages } from "./englishCrmMessages";
import { spanishCrmMessages } from "./spanishCrmMessages";
import { spanishMessages } from "./spanishMessages";
import { spanishRaMessages } from "./spanishRaMessages";
import { spanishResourceMessages } from "./spanishResourceMessages";

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  {
    "ra-supabase": {
      auth: {
        password_reset: "Check your emails for a Reset Password message.",
      },
    },
  },
  englishCrmMessages,
);

const spanishCatalog = mergeTranslations(
  englishCatalog,
  spanishMessages,
  spanishRaMessages,
  spanishResourceMessages,
  spanishCrmMessages,
);

export const getInitialLocale = (): "es" => "es";

export const i18nProvider = polyglotI18nProvider(
  () => spanishCatalog,
  getInitialLocale(),
  [{ locale: "es", name: "Español (Chile)" }],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
